module.exports = __webpack_public_path__ + "static/media/phone-mobile.26731ef9.png";